import { Injectable } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { IRotatingWidgetAnalytics, IWidgetAnalytics } from '../../interfaces/interfaces';

@Injectable()
export class AnalyticsService {
  constructor(
    private angulartics2: Angulartics2
  ) {
  }

  send(action: string, category: string, label?: string, value?: string): void {
    this.angulartics2.eventTrack.next({ action: action, properties: { category: category, label: label, value: value } });
  }

  getWidgetCategory(widget: IWidgetAnalytics) {
    return 'ng My Account ' + widget.widget_analytics_type() + ' - ' + widget.widget.analytics_title;
  }

  getRotatingWidgetCategory(widget: IRotatingWidgetAnalytics) {
    return 'ng My Account ' + widget.widget_analytics_type() + ' - ' + widget.analytics_title();
  }
}



// WEBPACK FOOTER //
// ./app/services/analytics/analytics.service.ts